// frontend/src/App.js
// Aplicación principal limpia y funcional según agent-instructions.md
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ThemeProvider from './styles/ThemeProvider';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider } from './components/common/Toast';
import { ConfirmProvider } from './components/common/ModalConfirmacion';
import { EntradaProvider } from './components/common/ModalEntrada';
import { FechaContadorProvider } from './components/common/ModalFechaContador';
import ErrorBoundary from './components/common/ErrorBoundary';
import AppRoutes from './routes/AppRoutes';

// Componente principal de la aplicación
const App = () => {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <ToastProvider>
          <ConfirmProvider>
            <EntradaProvider>
            <FechaContadorProvider>
            <AuthProvider>
              {/* Dentro de AuthProvider: si una pantalla falla, el aviso se muestra sin
                  perder la sesión ni el layout, y "Reintentar" re-monta solo las rutas. */}
              <ErrorBoundary>
                <AppRoutes />
              </ErrorBoundary>
            </AuthProvider>
            </FechaContadorProvider>
            </EntradaProvider>
          </ConfirmProvider>
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
